import { createStyles, makeStyles } from '@mui/styles';
import { ITheme } from 'theme/types';

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    container: {
      textAlign: 'center',
      padding: 10,
      border: `2px solid ${theme.palette.primary.main}`,
      cursor: 'pointer',
      borderRadius: '0.2em',
    },
    overContainer: {
      textAlign: 'center',
      padding: 10,
      border: `2px dashed ${theme.palette.primary.main}`,
      backgroundColor: theme.palette.grey[100],
      borderRadius: '0.2em',
    },
    fileInput: {
      display: 'none',
    },
    cloudIconStyle: {
      color: theme.palette.primary.main,
      fontSize: '2.2rem',
    },
  })
);

export default useStyles;
